<script setup lang="ts">
import { computed } from "vue";
import { useAppStore } from "@/ts/stores/app";
import Slideout from "@/ts/components/elements/slideout.vue";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import LanguageSwitch from "@/ts/components/elements/language-switch.vue";

const breakpoints = useBreakpoints(breakpointsTailwind);
const showNavigation = breakpoints.smaller("lg");

const appStore = useAppStore();

interface Props {
    centerLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    rightLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    translatedRoutes: { nl?: { relative_url: string; lang: string }; fr?: { relative_url: string; lang: string }; en?: { relative_url: string; lang: string } };
}

const props = defineProps<Props>();

const lang = computed(() => {
    return document.documentElement.lang;
});
</script>

<template>
    <slideout name="navigation" :show="appStore.navigation.slideout.visible && showNavigation" :show-close="false" :inverse="true" @close="appStore.navigation.slideout.visible = false">
        <div class="flex flex-col items-center justify-center flex-1 w-full gap-8">
            <a class="text-white text-lg" :href="`/${lang}`">{{ lang === "fr" ? "Accueil" : "Home" }}</a>
            <a v-for="page in centerLinks" :class="[page.class === 'link-unstyled' ? 'text-lg text-white inline-flex items-center uppercase' : page.class]" :href="page.url">
                {{ page.title }}
                <svg-vue v-if="page.class.indexOf('btn') >= 0" class="w-4 h-auto ml-2" icon="icons/arrow-right"></svg-vue>
                <span
                    v-else-if="page.url.indexOf('jobs') >= 0 && appStore.navigation.header.job_count > 0"
                    class="w-5 h-5 ml-2 rounded-full text-12 text-primary bg-white hover:border-white border-b-2 border-transparent inline-flex items-center justify-center font-bold leading-5 tracking-[.0025rem]"
                >
                    {{ appStore.navigation.header.job_count }}
                </span>
            </a>

            <div class="flex flex-col gap-8 items-center">
                <a v-for="page in rightLinks" :class="[page.class === 'link-unstyled' && appStore.navigation.header.sticky ? 'text-gray-900' : 'text-white', page.class === 'link-unstyled' ? 'text-lg text-white' : page.class]" :href="page.url">
                    {{ page.title }}
                    <svg-vue v-if="page.class.indexOf('btn') >= 0" class="w-4 h-auto ml-2" icon="icons/arrow-right"></svg-vue>
                </a>
            </div>
            <!--<div>
                <language-switch key="language-switch" :translated-routes="translatedRoutes"></language-switch>
            </div>-->
        </div>
    </slideout>
</template>

<style lang="scss" scoped></style>
